var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{on:{"click":function($event){return _vm.$store.dispatch('authenticateWithGithub')}}},[_vm._v(" Login with Github ")])}
var staticRenderFns = []

export { render, staticRenderFns }